import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { ContactButtons } from "./ContactButtons";
import { COMPANY, mailLink, telLink } from "../lib/company";
import { useT } from "../lib/i18n";

const VALUES = [COMPANY.name, `${COMPANY.address} - ${COMPANY.city}`, `${COMPANY.address} - ${COMPANY.city}`, COMPANY.piva, COMPANY.cf, COMPANY.rea];

export const Contact = () => {
  const t = useT();
  const c = t.contact;
  const LEGAL = c.legal.map((k, i) => [k, VALUES[i]]);
  return (
  <section id="contatti" className="py-20 md:py-32 bg-[var(--paper)] border-t border-[var(--line)]" data-testid="contact-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <Reveal className="mb-12 md:mb-16">
        <Eyebrow>{c.eyebrow}</Eyebrow>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-7xl font-semibold tracking-[-0.03em] leading-[0.95]">
          {c.t1} <span className="font-serif-i font-normal text-[var(--red)]">{c.em}</span>
        </h2>
      </Reveal>
      <div className="grid lg:grid-cols-12 gap-8">
        <Reveal className="lg:col-span-5 flex flex-col gap-6">
          <div className="space-y-5">
            <a href={COMPANY.mapLink} target="_blank" rel="noreferrer" className="group flex items-start gap-4" data-testid="contact-address-link">
              <MapPin className="w-5 h-5 mt-1 text-[var(--red)]" />
              <span><span className="block font-display text-2xl font-semibold group-hover:text-[var(--red)] transition-colors">{COMPANY.address}</span><span className="text-[var(--muted)]">{COMPANY.city} · {c.showroom}</span></span>
            </a>
            <a href={telLink} className="group flex items-center gap-4" data-testid="contact-phone-link">
              <Phone className="w-5 h-5 text-[var(--red)]" /><span className="font-display text-2xl font-semibold group-hover:text-[var(--red)] transition-colors">{COMPANY.phoneDisplay}</span>
            </a>
            <a href={mailLink()} className="group flex items-center gap-4" data-testid="contact-email-link">
              <Mail className="w-5 h-5 text-[var(--red)]" /><span className="font-display text-xl sm:text-2xl font-semibold group-hover:text-[var(--red)] transition-colors break-all">{COMPANY.email}</span>
            </a>
          </div>
          <ContactButtons prefix="contact" />
          <dl className="mt-2 rounded-[22px] border border-[var(--line)] bg-white divide-y divide-[var(--line)]" data-testid="contact-legal-box">
            {LEGAL.map(([k, v]) => (
              <div key={k} className="flex flex-col sm:flex-row sm:justify-between gap-1 px-5 py-3.5 text-sm">
                <dt className="text-[var(--muted)]">{k}</dt><dd className="font-semibold sm:text-right">{v}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="relative h-[380px] md:h-full min-h-[420px] rounded-[28px] overflow-hidden border border-[var(--line)] bg-[#E9E6DE]">
            <iframe title="Mappa YOUCARS Lecco" src={COMPANY.mapEmbed} className="absolute inset-0 w-full h-full grayscale-[0.6] contrast-[1.05]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map" />
            <a href={COMPANY.mapLink} target="_blank" rel="noreferrer" data-testid="contact-directions-btn"
              className="absolute left-4 bottom-4 inline-flex items-center gap-2 rounded-full bg-[var(--ink)] text-white px-5 py-3 text-sm font-semibold hover:bg-[var(--red)] transition-colors">
              {c.directions} <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
